import { BaseNavigationService } from '@shared/utils/navigation';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Check404Interceptor, PreviewUserHeadingServiceBase, SharedFeaturePageLayoutModule } from '@shared/feature/page-layout';
import { SharedFeatureTranslateRootModule } from '@shared/feature/translate';
import { RouterModule } from '@angular/router';
import { BaseAuthService } from '@shared/utils/base-auth';
import { SharedUiPageToolbarsModule } from '@shared/ui/page-toolbars';
import { SharedUiCardsModule } from '@shared/ui/cards';
import { SharedUiTablesModule } from '@shared/ui/tables';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SharedFeatureTenantModule } from '@shared/feature/tenant';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoadingInterceptor, SharedFeatureLoadingModule } from '@shared/feature/loading';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { IMPORTS } from './intrensic-shell-debug-imports';
import { webRoutes } from './intrensic-shell.routes';
import { MenuItemsService } from '@shared/utils/menu-items';
import { MenuService } from './services/menu/menu.service';
import { BaseAgencyDetailsService, SharedFeatureAgencyDetailsModule } from '@shared/feature/agency-details';
import { IntrensicSharedOfficerDetailsModule, OfficerDetailsService } from '@intrensic/shared/officer-details';
import { AgencyDetailsService } from './services/agency-details/agency-details.service';
import { UploadImageService } from '@shared/feature/upload-file';
import { UnauthorizedInterceptor } from './interceptors/unauthorized.interceptor';
import { ErrorInterceptor } from '@shared/feature/notification-handling';
import { BaseListOfficerService } from '@shared/feature/list-officer';
import { IntrensicListOfficersService } from './services/list-officer/intrensic-list-officers.service';
import { IntrensicAgencyManagementDataAccessModule } from '@intrensic/agency-management/data-access';
import { BaseDateTimeService } from '@shared/utils/date-time';
import { DateTimeService } from '@intrensic/shared/date-time';
import { SharedUtilsTimeagoModule } from '@shared/utils/timeago';
import { IntrensicAgencyUploadImageService } from './services/upload-image/intrensic-agency-upload-image.service';
import { GoogleMapsModule } from '@angular/google-maps';
import { MarkdownModule } from 'ngx-markdown';
import { BaseB2cAuthService, SharedFeatureB2cAuthModule } from '@shared/feature/b2c-auth';
import { PreviewUserHeadingService } from './services/preview-user-heading/preview-user-heading.service';
import { ResourceAvailabiltyService } from './services/resource-availability/resource-availabilty.service';
import { BaseResourceAvailabilityService } from '@shared/data-access';
import { OfficerDetailsBaseService } from '@shared/utils/officer';
import { NavigationService } from './services/navigation/navigation.service';
import { CacheService } from '@shared/utils/cache';
import { CacheImplementationService } from './services/cache/cache-implementation.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule.forRoot(webRoutes),
    BrowserAnimationsModule,
    BrowserModule,
    SharedUiCardsModule,
    SharedUiTablesModule,
    SharedFeaturePageLayoutModule,
    SharedFeatureTranslateRootModule,
    SharedUiPageToolbarsModule,
    SharedFeatureAgencyDetailsModule,
    IntrensicAgencyManagementDataAccessModule,
    IntrensicSharedOfficerDetailsModule,
    SharedFeatureB2cAuthModule,
    StoreModule.forRoot(
      {},
      {
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true,
        },
      }
    ),
    IMPORTS,
    EffectsModule.forRoot([]),
    SharedFeatureTenantModule,
    SharedFeatureLoadingModule,
    SharedUtilsTimeagoModule,
    GoogleMapsModule,
    MarkdownModule.forRoot(),
  ],
  providers: [
    { provide: BaseAuthService, useClass: BaseB2cAuthService },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Check404Interceptor,
      multi: true,
    },
    { provide: MenuItemsService, useClass: MenuService },
    { provide: BaseAgencyDetailsService, useClass: AgencyDetailsService },
    { provide: UploadImageService, useClass: IntrensicAgencyUploadImageService },
    { provide: BaseListOfficerService, useClass: IntrensicListOfficersService },
    { provide: BaseDateTimeService, useClass: DateTimeService },
    { provide: PreviewUserHeadingServiceBase, useClass: PreviewUserHeadingService },
    { provide: BaseResourceAvailabilityService, useClass: ResourceAvailabiltyService },
    { provide: OfficerDetailsBaseService, useClass: OfficerDetailsService },
    { provide: BaseNavigationService, useClass: NavigationService },
    { provide: CacheService, useClass: CacheImplementationService },
  ],
  exports: [RouterModule],
})
export class IntrensicShellModule {}
